import React from 'react';
import { managementServices as data, contact } from '../../content/site';
import { ArrowRight, Check, Mail } from '../Common/Icons';

const AboutManagement = () => (
  <>
    <section className="section">
      <div className="container">
        <div className="detail__grid">
          <div className="detail__media reveal">
            <img
              src={data.image}
              alt="LIDA Engineering crew working from scaffolding on a structural steel span"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="detail__body reveal" style={{ '--reveal-delay': '100ms' }}>
            <p className="eyebrow">Overview</p>
            <p className="detail__lead">{data.lead}</p>

            {data.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

            <div className="detail__cta">
              <a href={`mailto:${contact.email}`} className="btn">
                Request a Quote
                <ArrowRight />
              </a>
              <a href="#contact" className="btn btn--outline">
                <Mail />
                Contact us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section section--paper2">
      <div className="container">
        <div className="section-head section-head--center">
          <p className="eyebrow">Scope</p>
          <h2>What we take responsibility for.</h2>
        </div>

        {data.groups.map((group) => (
          <div className="group" key={group.title}>
            <h3 className="group__title">{group.title}</h3>
            <ul className="group__list">
              {group.items.map((item) => (
                <li className="group__item" key={`${group.title}-${item.term}`}>
                  <Check className="group__check" size={18} />
                  <span>
                    <span className="group__term">{item.term}:</span>{' '}
                    <span className="group__detail">{item.detail}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default AboutManagement;
